import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import InstallWebPackageManagers from "./install-web-package-managers.mdx";
import CalloutBox from 'components/Docs/CalloutBox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`For Next.js, we recommend following the `}<a parentName="p" {...{
          "href": "/docs/integrate/next-js"
        }}>{`Next.js integration guide`}</a>{` instead.`}</p>
    </blockquote>
    <ol>
      <li parentName="ol">{`Install `}<a parentName="li" {...{
          "href": "https://github.com/posthog/posthog-js"
        }}><inlineCode parentName="a">{`posthog-js`}</inlineCode></a>{` using your package manager:`}</li>
    </ol>

    <InstallWebPackageManagers mdxType="InstallWebPackageManagers" />
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Add your environment variables to your `}<inlineCode parentName="li">{`.env.local`}</inlineCode>{` file and to your hosting provider (e.g. Vercel, Netlify, AWS). You can find your project API key and host in `}<a parentName="li" {...{
          "href": "https://us.posthog.com/settings/project"
        }}>{`your project settings`}</a>{`. Including `}<inlineCode parentName="li">{`VITE_PUBLIC_`}</inlineCode>{` in their names ensures they are accessible in the frontend.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell",
        "metastring": "file=.env.local",
        "file": ".env.local"
      }}>{`VITE_PUBLIC_POSTHOG_KEY=<ph_project_api_key>
VITE_PUBLIC_POSTHOG_HOST=<ph_client_api_host>
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Integrate PostHog at the root of your app (such as `}<inlineCode parentName="li">{`main.jsx`}</inlineCode>{` if you are using Vite).`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-react"
      }}>{`// src/main.jsx
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react'

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '<ph_posthog_js_defaults>',
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </StrictMode>,
)
`}</code></pre>

    <CalloutBox icon="IconWarning" title="Don't directly import PostHog" type="fyi" mdxType="CalloutBox">
      <p>{`  Do not directly import `}<inlineCode parentName="p">{`posthog`}</inlineCode>{` apart from installation as shown above. This will likely cause errors as the library might not be initialized yet. Initialization is handled automatically when you use the `}<inlineCode parentName="p">{`PostHogProvider`}</inlineCode>{` and `}<inlineCode parentName="p">{`usePostHog`}</inlineCode>{` hook.`}</p>
    </CalloutBox>
    <details>
  <summary>Using React Router v7?</summary>
      <p>{`  You need to set `}<inlineCode parentName="p">{`posthog-js`}</inlineCode>{` and `}<inlineCode parentName="p">{`posthog-js/react`}</inlineCode>{` as external packages in your `}<inlineCode parentName="p">{`vite.config.ts`}</inlineCode>{` file to avoid SSR errors.`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-ts",
          "metastring": "file=vite.config.ts",
          "file": "vite.config.ts"
        }}>{`// ... imports

export default defineConfig({
  plugins: [tailwindcss(), reactRouter(), tsconfigPaths()],
  ssr: {
    noExternal: ['posthog-js', 'posthog-js/react']
  }
});
`}</code></pre>
      <p>{`  See our `}<a parentName="p" {...{
          "href": "/docs/libraries/remix"
        }}>{`Remix docs`}</a>{` for more details.`}</p>
    </details>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      